
// MAIN APP IMPORT AND STYLES
import React from 'react';
import '../styles/App.css';

// IMPORT IMAGES FOR THIS COMPONENT
import thumbUp from '../images/thumb-up.png'
import thumbDown from '../images/thumb-down.png'

// HELPER FUNCTION IMPORT
let tr = require( '../utils/translations' ).translate;


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class ResultComponent extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = { blobSource: this.b64toBlob( this.props.App.state.gifSource ) };

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'result'
		} )
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		let state = this.state,
			AppState = this.props.App.state,
			feedBackInput;

		// KEEP THIS AROUND INCASE WE EVER WANT TO TAKE ANOTHER LOOK AT BLOBS
		// URL.createObjectURL( this.state.blob )}

		if ( state.showFeedbackInput ) feedBackInput = <div className="input-text">
			<input maxLength={255} onInput={( e ) => this.submitFeedback( e )} type="text" placeholder={tr( 'Tell us what happened?', '发生什么惹(°ー°〃)，告诉我们~' )} />
		</div>;

		return (
			<div id="resultPanel">

				<article>
					<h2>{tr( 'Ta-da... your GIF is finished!', '出炉啦！你的GIF已经完成！' )}</h2>
					{window.checkMobile() ? <small>{tr( 'Long press your GIF to save it to your gallery.', '长按将生成的GIF保存到相册' )}</small> : null }
				</article>

				<div className="image-container"
					 style={{ maxHeight: AppState.canvasHeight }}>
					<img src={ AppState.gifSource }/>
				</div>

				<article>
					<p>{tr( 'GIF size: ', 'GIF图片尺寸: ' ) + AppState.trueGifSize}mb</p>

					<div className="btn-group">

						{window.checkMobile() ? null : <a download={ AppState.videoName + '.gif' } onClick={( e ) => this.downloadClicked( e )}
						   href={URL.createObjectURL( state.blobSource )}
						   className="btn btn-gold">{tr( 'Download', '保存下载' )}</a>}

						<button className="btn btn-light"
								onClick={( e ) => this.returnToUpload( e )}
								style={ window.checkMobile() ? {} : {marginLeft: '20px'} }>
							{tr( 'Make another GIF', '重做一遍' )}
						</button>
					</div>

					{feedBackInput
						? feedBackInput
						: state.submittedFeedback
							? <h3>{tr( 'Thank you for your feedback', '感谢你的反馈' )}</h3>
							: <div className="btn-group">

								{ window.checkMobile() ? null : <div className="btn-text" style={{marginRight: '5px'}}>
									<h3>{tr( 'How does it look?', '动次好用吗？' )}</h3>
								</div>}

								<div className="btn btn-light btn-half btn-like"
									 data-id="like"
									 onClick={( e ) => this.sendFeedback( e )}
									 style={{
									 	 marginLeft: window.checkMobile() ? '0' : '20px',
										 backgroundImage: 'url(' + thumbUp + ')'
									 }}/>

								<div className="btn btn-light btn-half btn-like"
									 data-id="dislike"
									 onClick={( e ) => this.sendFeedback( e )}
									 style={{backgroundImage: 'url(' + thumbDown + ')' }}/>
							</div>}
				</article>
			</div>
		);
	}


	// =============================================================================================
	returnToUpload() {

		window.mixpanel.track( 'Navigate', {
			app: 'video-to-gif',
			action: 'returned-to-upload'
		} );

		this.props.App.setState( prevState => ({ tab: 1 }) )
	}


	// =============================================================================================
	downloadClicked() {

		window.mixpanel.track( 'Image', {
			app: 'video-to-gif',
			action: 'downloaded-gif',
			size: this.props.App.state.trueGifSize,
			quality: this.props.App.state.selectedQuality || 'medium'
		} );
	}


	// =============================================================================================
	sendFeedback( e ) {
		let action = e.target.dataset.id;

		if ( action === 'dislike' ) {

			this.setState( prevState => ({ showFeedbackInput: true }) );

			setTimeout( function() {

				document.getElementsByClassName( 'input-text' )[0].children[0].focus();
			}, 50 );

			window.mixpanel.track( 'Feedback', {
				app: 'video-to-gif',
				action: action
			} );

		} else {

			this.setState( prevState => ({ submittedFeedback: true }) );

			window.mixpanel.track( 'Feedback', {
				app: 'video-to-gif',
				action: action
			} );
		}
	}


	// =============================================================================================
	submitFeedback( e ) {

		if( e.keyCode === 13 || e.charCode === 13 ) {
			e.preventDefault();

			window.mixpanel.track( 'Feedback', {
				app: 'video-to-gif',
				action: 'dislike',
				message: e.target.value
			} );

			this.setState( prevState => ({
				showFeedbackInput: false,
				submittedFeedback: true
			}) );
		}
	}


	// =============================================================================================
	b64toBlob( b64Data, contentType, sliceSize ) {
		contentType = contentType || '';
		sliceSize = sliceSize || 512;

		let byteCharacters = atob( b64Data.replace( /^data:image\/(gif);base64,/, '' ) ),
			byteArrays = [];

		for ( let offset = 0; offset < byteCharacters.length; offset += sliceSize ) {
			let slice = byteCharacters.slice( offset, offset + sliceSize ),
				byteNumbers = new Array( slice.length );

			for ( let i = 0; i < slice.length; i++ ) {

				byteNumbers[ i ] = slice.charCodeAt( i );
			}

			byteArrays.push( new Uint8Array( byteNumbers ) );
		}

		// RETURN THE BLOB OBJECT
		return new Blob( byteArrays, { type: contentType } );
	}
}

export default ResultComponent;



// WEBPACK FOOTER //
// ./src/app/scenes/result.js